import { render, staticRenderFns } from "./examine.vue?vue&type=template&id=164e34db&scoped=true"
import script from "./examine.vue?vue&type=script&lang=js"
export * from "./examine.vue?vue&type=script&lang=js"
import style0 from "./examine.vue?vue&type=style&index=0&id=164e34db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e34db",
  null
  
)

export default component.exports